import React from 'react';

import { styled } from '@mui/material/styles';

const Container = styled('section')`
  background-color: white;

  .long-copy {
    margin-bottom: 30px;
  }


  img {
    display: flex;
    justify-self: center;
    cursor: pointer;
  }
`;

type Props = {
  className?: string;
};

const Certifications = ({ className }: Props) => {
  return (<Container className={className} id='certifications'>
    <div className='row'>
      <h2>Certifications</h2>
      <p className='long-copy'>
        Fully ACI and SCDOT certified: we are qualified to pour residential, commercial, and state‑level work throughout South Carolina.
      </p>
    </div>
  </Container>
  )
};

export default Certifications;
